import * as _ from "lodash";
import { PositionBalancesLoaded, PositionBalanceAdded, PositionBalanceUpdated, PositionBalanceRemoved } from "./longShort.actions";
import { PositionBalance } from "./positionBalance";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";

export class PositionBalanceReducer extends ReducerBase<PositionBalance[]> {
    constructor() {
        super();
        this.addHandler(PositionBalancesLoaded.EventName, this.handlePositionBalancesLoaded);
        this.addHandler(PositionBalanceUpdated.EventName, this.handlePositionBalanceUpdated);
        this.addHandler(PositionBalanceRemoved.EventName, this.handlePositionBalanceRemoved);
    }

    handlePositionBalancesLoaded(
        state: PositionBalance[] = initialState.positionBalances,
        event: PositionBalancesLoaded
    ): PositionBalance[] {
        return event.positionBalances;
    }

    handlePositionBalanceAdded(state: PositionBalance[], event: PositionBalanceAdded): PositionBalance[] {
        return [...state, { ...event.positionBalance }];
    }

    handlePositionBalanceUpdated(state: PositionBalance[], event: PositionBalanceUpdated): PositionBalance[] {
        return _.unionBy([event.positionBalance], state, m => m.id);
    }

    handlePositionBalanceRemoved(state: PositionBalance[], event: PositionBalanceRemoved): PositionBalance[] {
        return state.filter(t => (t.id !== event.positionBalance.id));
    }

    handleDefault(state: PositionBalance[] = initialState.positionBalances) {
        return state;
    }
}